import { Controller } from "@hotwired/stimulus"

// Topbar notification bell. Opens the dropdown, and once its lazy frame has
// loaded, marks exactly the notifications on screen as read.
//
// Marking read is a POST rather than a side effect of the dropdown's GET:
// Turbo prefetches frames on hover, which would otherwise silently clear
// someone's badge as their pointer passed the bell.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
    document.addEventListener("click", this.closeOnOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick)
  }

  toggle(event) {
    event.stopPropagation()
    this.panelTarget.classList.toggle("hidden")
    if (!this.panelTarget.classList.contains("hidden")) this.markVisibleRead()
  }

  closeOnOutsideClick(event) {
    if (this.element.contains(event.target)) return
    this.panelTarget.classList.add("hidden")
  }

  // The dropdown's frame is lazy: on first open it has not fetched yet, and it
  // does not reliably carry [busy] at the instant we toggle. So poll briefly
  // for rows rather than racing a single event.
  markVisibleRead(attempt = 0) {
    if (this.panelTarget.classList.contains("hidden")) return

    const ids = this.visibleIds()

    if (ids.length > 0) {
      this.postIds(ids)
    } else if (attempt < 20) {
      setTimeout(() => this.markVisibleRead(attempt + 1), 150)
    }
  }

  visibleIds() {
    return Array.from(
      this.panelTarget.querySelectorAll("[data-notification-id]")
    ).map((el) => el.dataset.notificationId)
  }

  postIds(ids) {
    if (ids.length === 0) return

    const body = new FormData()
    ids.forEach((id) => body.append("ids[]", id))

    fetch(this.element.dataset.notificationsReadUrl, {
      method: "POST",
      body,
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
        Accept: "text/vnd.turbo-stream.html"
      }
    })
      .then((response) => response.text())
      .then((html) => window.Turbo.renderStreamMessage(html))
  }
}
